import { S3_IMAGES_URL } from '../../../constants';

export const PLANETS = [
  {
    id: 1,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-01@3x.png`,
  },
  {
    id: 2,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-02@3x.png`,
  },
  {
    id: 3,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-03@3x.png`,
  },
  {
    id: 4,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-04@3x.png`,
  },
  {
    id: 5,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-05@3x.png`,
  },
  {
    id: 6,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-06@3x.png`,
  },
  {
    id: 7,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-07@3x.png`,
  },
  {
    id: 8,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-08@3x.png`,
  },
  {
    id: 9,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-09@3x.png`,
  },
  {
    id: 10,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-10@3x.png`,
  },
  {
    id: 11,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-11@3x.png`,
  },
  {
    id: 12,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-12@3x.png`,
  },
  {
    id: 13,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-13@3x.png`,
  },
  {
    id: 14,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-14@3x.png`,
  },
  {
    id: 15,
    src: `${S3_IMAGES_URL}planets_for_collection/planet-15@3x.png`,
  },
];
